module.exports = __webpack_public_path__ + "img/pr-25.ef0ef22a.png";